import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGameConfig } from '../context/GameConfigContext';
import './DevModeBanner.css';

const DevModeBanner = () => {
  const { t } = useTranslation('common');
  const { gelistirmeConsole } = useGameConfig();

  if (!gelistirmeConsole) {
    return null;
  }

  return (
    <div className="dev-mode-banner" role="status" aria-live="polite">
      {t('devModeActive')}
    </div>
  );
};

export default DevModeBanner;
